export const COLOR = {
  gray50: '#f7f8fb',
  gray100: '#ebecf2',
  gray200: '#d8dae5',
  gray300: '#a2abb8',
  gray400: '#848e9e',
  gray500: '#828699',
  gray600: '#696c80',
  gray700: '#515466',
  gray800: '#22262e',
  gray900: '#151a1f',
  gray950: '#0e1217',
  gray1000: '#12131a',
  primary: '#3259e8',
  primaryForeground: '#ffffff',
  secondary: '#e2e5eb',
  secondaryHover: '#c3c9d1',
  secondaryForeground: '#000000',
  border: '#c3c9d1',
  borderMuted: '#e2e5eb',
  borderHover: '#a2abb8',
  borderFocus: '#3259e8',
  bodyBackground: '#ffffff',
  bodyFont: '#000000',
  mutedFont: '#a2abb8',
  white: '#ffffff',
  headingFont: '#000000',
  subheadingFont: '#626D7C'
}; // Base colors for the theme
// from light to dark

export const BASE_COLORS = ['#e2e5eb', '#c3c9d1', '#a2abb8', '#848e9e', '#626d7c', '#4c5563', '#343b45', '#22262e'];
export const COLOR_PALLETS = [{
  name: 'Default',
  colors: ['#3259e8', ...BASE_COLORS]
}, {
  name: 'Success',
  colors: ['#00823e', ...BASE_COLORS]
}, {
  name: 'Danger',
  colors: ['#c32518', ...BASE_COLORS]
}];